import type { IconSvgObject } from './types';

const FlipRightIcon: IconSvgObject = [
  ["path", { d: "M15 3H16M19 3C20.6569 3 22 4.34315 22 6M15 21H16M19 21C20.6569 21 22 19.6569 22 18M22 10V14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 6C2 4.34315 3.34315 3 5 3H11C11.5523 3 12 3.44772 12 4V20C12 20.5523 11.5523 21 11 21H5C3.34315 21 2 19.6569 2 18V6Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FlipRightIcon;
